<div
  *ngIf="stores.length"
  (scroll)="onScroll($event)"
  class="sp-width__full sp-overflow__x-scroll sp-position__relative sp-card sp-table__sticky-header">
  <table
    mat-table
    [dataSource]="stores"
    class="sp-width__full">
    <ng-container matColumnDef="store_id">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'STORES.ID_COLUMN_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let store">
        <app-shared-id
          [content]="store.store_id"
          [content_class]="'sp-color__primary'"
          [is_shrinked_id]="true"></app-shared-id>
      </td>
    </ng-container>

    <ng-container matColumnDef="logo">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'STORES.LOGO_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let store">
        <app-shared-store-logo
          size="m"
          [current_store_logo]="store?.logo_url"></app-shared-store-logo>
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'GENERAL.NAME_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let store">
        <span
          *ngIf="store.name"
          class="sp-color__primary sp-text__ellipsized sp-text__bold">
          {{ store.name?.length > 30 ? (store.name | slice : 0 : 30) + '...' : store.name }}
        </span>
        <span *ngIf="!store.name"> - </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'ORDERS.STATUS_COLUMN_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let store">
        <div class="sp-row__align">
          <div
            class="sp-circle__xs sp-margin__right"
            [matTooltip]="getStoreStatusLabel(store) | translate"
            [ngClass]="getStoreStatusBackgroundClass(store)"></div>
          <h5 class="sp-color__primary">{{ getStoreStatusLabel(store) | translate }}</h5>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="company_business_name">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'STORES.BUSINESS_NAME_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let store">
        <span class="sp-color__primary sp-text__ellipsized"> {{ store.company_business_name || '-' }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="company_vat">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'STORES.VAT_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let store">
        <span class="sp-color__primary sp-text__ellipsized"> {{ store.company_vat || '-' }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="created_at">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'STORES.REGISTRATION_DATE_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let store">
        <span class="sp-color__primary sp-text__ellipsized"> {{ store.created_at | date : 'short' }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="phone">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'GENERAL.PHONE_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let store">
        <span class="sp-color__primary sp-text__ellipsized">
          {{ store.phone.prefix }}
          {{ store.phone.value }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'GENERAL.EMAIL_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let store">
        <span class="sp-color__primary sp-text__ellipsized">
          {{ store.email }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="address">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'GENERAL.BIRTH_PLACE_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let store">
        <span class="sp-color__primary sp-text__ellipsized">
          {{ store.address.line1 | titlecase }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="city">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'GENERAL.CITY_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let store">
        <span class="sp-color__primary sp-text__ellipsized">
          {{ store?.address?.city || '-' | titlecase }}
          ({{ store?.address?.state || '' | uppercase }})
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="postal_code">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'GENERAL.POSTAL_CODE_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let store">
        <span class="sp-color__primary sp-text__ellipsized">
          {{ store.address.postal_code }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="sales_network_id">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'COMPANIES.SALES_NETWORK_ID_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let store">
        <div class="sp-row__align">
          <span class="sp-color__primary sp-text__ellipsized"> {{ store.sales_network_id || '-' }} </span>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="cms">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'COMPANIES.CMS_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let store">
        <span class="sp-color__primary sp-text__ellipsized"> {{ store.cms || '-' }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="min_amount">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'STORES.MIN_AMOUNT_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let store">
        <span class="sp-color__primary sp-text__ellipsized">
          {{ store.order_requirements.min_amount / 100 || 0 | number : '0.2-2' }}</span
        >
      </td>
    </ng-container>

    <ng-container matColumnDef="max_amount">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'STORES.MAX_AMOUNT_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let store">
        <span class="sp-color__primary sp-text__ellipsized">
          {{ store.order_requirements.max_amount / 100 || 0 | number : '0.2-2' }}</span
        >
      </td>
    </ng-container>

    <ng-container matColumnDef="custom_subdomain">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized"> Custom subdomain </span>
      </th>
      <td
        mat-cell
        *matCellDef="let store">
        <span class="sp-color__primary sp-text__ellipsized"> {{ store.company_custom_buyer_subdomain || '-' }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="store_type">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized"> {{ 'STORES.STORE_TYPE' | translate }} </span>
      </th>
      <td
        mat-cell
        *matCellDef="let store">
        <span class="sp-color__primary sp-text__ellipsized"> {{ getStoreTypeLabel(store) | translate }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="agreement">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'GENERAL.AGREEMENT_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let store">
        <span class="sp-color__primary sp-text__ellipsized"> {{ store.agreement || '-' }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">{{ 'ORDERS.ACTIONS_COLUMN_LABEL' | translate }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let store">
        <div class="sp-row__align">
          <button
            mat-icon-button
            class="sp-icon__button sp-icon__button-dark sp-margin__left"
            [matTooltip]="'GENERAL.SEE_DETAILS_CTA' | translate">
            <mat-icon class="material-symbols-outlined"> visibility </mat-icon>
          </button>
        </div>
      </td>
    </ng-container>

    <tr
      mat-header-row
      *matHeaderRowDef="displayed_columns; sticky: true"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayed_columns"
      class="sp-cursor__pointer"
      (click)="onDetailsClick(row)"></tr>
  </table>
</div>
